// The ⌘K palette's search — TODO T36 (2 Sep 2026), design doc § T36.6.
//
// One term, three groups, deterministic: the service matches substrings over the columns the
// design names and nothing else, so a name finds the same rows every time. Not polled — a
// palette is open for seconds — and the previous answer is kept on screen while the next one is
// in flight, so the list does not blink empty between keystrokes.
//
// A SENTENCE typed into the same field is T35's (the find panel, with its own prompt and its own
// database role); this module never sends one anywhere.
import { keepPreviousData, useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { PaletteResponse } from '@vera/bff';
import { API_PREFIX, query, type RequestFn } from './core.ts';
import { useRequest } from './provider.tsx';

export const paletteApi = (request: RequestFn) => ({
  search: (q: string, limit?: number) =>
    request<PaletteResponse>(`${API_PREFIX}/search${query({ q, limit })}`),
});

export function usePalette(q: string): UseQueryResult<PaletteResponse> {
  const request = useRequest();
  const term = q.trim();
  return useQuery({
    queryKey: ['palette', term],
    queryFn: () => paletteApi(request).search(term),
    enabled: term !== '',
    placeholderData: keepPreviousData,
    // A term retyped within a few seconds is the same answer; a palette is not a poll.
    staleTime: 10_000,
  });
}
